<template>
<!-- <div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">User Profile</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label>First Name</label>
            <input type="text" class="form-control" v-model="mm.firstName" id="firstName" aria-describedby="action">
        </div>
        <div class="form-group col-3">
            <label>Last Name</label>
            <input type="text" class="form-control" v-model="mm.lastName" id="lastName" aria-describedby="action">
        </div>
        
    </div>
    <div class="row">
        <div class="form-group col-3">
            <label for="module">Email</label>
            <input type="text" class="form-control" disabled v-model="mm.email" id="email" aria-describedby="module">
        </div>
        <div class="form-group col-3">
            <label for="module">Phone Number</label>
            <input type="text" class="form-control" v-model="mm.phoneNumber" id="phoneNumber" aria-describedby="module">
        </div>
    </div>
    
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="cancel">Close Page <i class="far fa-window-close"></i></button>
    <br /><br />
</div> -->
<div id="main-content" class="taskboard">
        <div class="container-fluid">
            <div class="block-header">
                <div class="row">
                    <div class="col-lg-6 col-md-8 col-sm-12">
                        <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
                        <ul class="breadcrumb">
                            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
                            <li class="breadcrumb-item">Apps</li>
                            <li class="breadcrumb-item active">Tickets</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- <div class="row clearfix">
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <div class="sparkline-pie">5,3,2</div>
                            <h3 class="m-b-0 m-t-10">2078</h3>
                            <span >Total Tickets</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <input type="text" class="knob2" data-readOnly="true" value="50" data-width="90" data-height="90" data-thickness="0.15"  data-fgColor="#00ca70">
                            <h3 class="m-b-0 m-t-10">1278</h3>
                            <span>Resolve</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <input type="text" class="knob2" data-readOnly="true" value="30" data-width="90" data-height="90" data-thickness="0.15"  data-fgColor="#4b78b8">
                            <h3 class="m-b-0 m-t-10">521</h3>
                            <span>Pending</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="body text-center">
                            <input type="text" class="knob2" data-readOnly="true" value="20" data-width="90" data-height="90" data-thickness="0.15"  data-fgColor="#ffbf00">
                            <h3 class="m-b-0 m-t-10">978</h3>
                            <span>Responded</span>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12">
                    <div class="card">
                        <div class="header">
                            <h2>User Profile</h2>
                        </div>
                        <!-- <div class="body">
                            <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
                            <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
                            <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Close <i class="far fa-trash-alt"></i></button>
                            <app-datatable :type="'view'" :elements="dtElements" :collections="ticket" v-on:selectedRow="selectRow"></app-datatable>
                            <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
                        </div> -->
                        <div class="body">
                            <div class="row">
                                <div class="form-group col-3">
                                    <label for="first-name">First Name</label>
                                    <input type="text" class="form-control" v-model="mm.firstName" id="first-name" aria-describedby="code">
                                </div>
                                <div class="form-group col-3">
                                    <label for="last-name">Last Name</label>
                                    <input type="text" class="form-control" v-model="mm.lastName" id="last-name" aria-describedby="code">
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-3">
                                    <label for="email">Email</label>
                                    <input type="text" class="form-control" v-model="mm.email" id="email" aria-describedby="code" disabled>
                                </div>
                                <div class="form-group col-3">
                                    <label for="phone-number">Phone Number</label>
                                    <input type="text" class="form-control" v-model="mm.phoneNumber" id="phone-number" aria-describedby="code">
                                </div>
                                <div class="form-group col-3">
                                    <label for="password">New Password</label>
                                    <input type="password" class="form-control" v-model="mm.password" id="newPassword" aria-describedby="password">
                                </div>
                            </div>
                            <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
                            <button type="button" class="btn btn-outline-danger" @click="cancel">Close Page <i class="far fa-window-close"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../services/api'
import { memberManagement } from '../models/memberManagement'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatatable from '../components/AppDatatable.vue'
import AppDatePicker from '../components/AppDatePicker.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker
    },
    data() {
        return {
            mm: {
                ...memberManagement
            }
        }
    },
    async created() {
        // if(this.$route.query.id !== undefined) {
        //     const mmApi = api('user-profile')
        //     this.mm = await mmApi.get()
        //     // this.mm = await mmApi.getWithParams(this.$route.query.id)
        // }
        const mmApi = api('user-profile')
        this.mm = await mmApi.get()
    },
    methods: {
        async save() {
            const mmApi = api('user-profile')
            await mmApi.update(this.mm)
            this.$router.go(-1)
            // if(this.$route.query.id !== undefined) {
            //     console.log('a')
            //     await mmApi.update(this.mm, this.$route.query.id)
            // } else {
            //     console.log('b')
            //     await mmApi.create(this.mm)
                
            // }
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentMM = this.mm
            this.mm = {
                ...currentMM,
                ...data
            }
        }
    }
}
</script>